<template>
  <div class="cx_style deng cx-check-box">
    <el-checkbox-group v-model="checkBoxValue" class="custom-item-checkbox">
      <el-checkbox :key="index" :label="item.value" v-for="(item, index) in checkBoxList"></el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import complexSetMixin from "./complexSetMixin.js"

export default {
  name: "cxCheckBoxGroup",
  mixins: [
    complexSetMixin()
  ],
  props: {
    defaultValue: undefined,
    config: undefined
  },
  computed: {
    checkBoxValue: {
      get() {
        console.log('this.configData :>>',this.configData.checkBoxValue);
        
        return this.configData.checkBoxValue
      },
      set(newVal) {
        console.log('newVal :>>',newVal);
        
        this.configData.checkBoxValue = newVal
      }
    },
    checkBoxList: {
      get() {
        return this.configData.checkBoxList
      },
      set(newVal) {
        this.configData.checkBoxList = newVal
      }
    },
  }
}
</script>

<style scoped lang="scss">
.el-checkbox {
  margin-right: 7px;
  &:last-child {
    margin-right: 0;
  }
}
::v-deep .el-checkbox__label {
  padding-left: 4px;
}
</style>
